export default __webpack_public_path__ + "b21101d2c2318936493c9ce0c3a17163.svg";